<template>
  <teleport to="body">
    <CustomAlert 
      v-if="alertStore.show"
      :show="alertStore.show"
      :type="alertStore.type"
      :title="alertStore.title"
      :message="alertStore.message"
      :confirmText="alertStore.confirmText"
      :showCancel="alertStore.showCancel"
      :closeOnOverlay="alertStore.closeOnOverlay"
      @confirm="handleConfirm"
      @cancel="handleCancel"
      @close="handleClose"
    />
  </teleport>
</template>

<script>
import CustomAlert from './CustomAlert.vue'
import { alertStore } from '@/utils/alertStore'

export default {
  name: 'GlobalAlert',
  components: {
    CustomAlert
  },
  setup() {
    const handleConfirm = () => {
      if (alertStore.onConfirm) {
        alertStore.onConfirm()
      }
    }
    
    const handleCancel = () => {
      if (alertStore.onCancel) {
        alertStore.onCancel()
      }
    }
    
    const handleClose = () => {
      alertStore.show = false
    }
    
    return {
      alertStore,
      handleConfirm,
      handleCancel,
      handleClose
    }
  }
}
</script>